<script>
  import { statuses } from './statuses.js';
  import LegendCell from './LegendCell.svelte';
  import Reset from './Reset.svelte';

  export let hasIntro;
  export let character = {};
  export let relationship = {};
</script>

<style>
  .heading {
    overflow: hidden;
  }
  .section-label {
    font-size: 16.4px;
  }
  @media (min-width: 560px) {
    .columns .legend-list {
      column-count: 2;
    }
  }
</style>

<div class="legend" class:columns={!hasIntro}>
  <div class="heading">
    {#if ('name' in character) || ('characters' in relationship)}
    <Reset on:reset/>
    {/if}
    <div class="section-label">Legend</div>
  </div>
  <div class="legend-list">
    {#each Object.keys(statuses) as status}
      <LegendCell relationship="{status}"/>
    {/each}
  </div>
</div>